import { 
  memo, 
  useRef, 
  useState,
  useEffect, 
  Fragment, 
  useCallback,
} from "react";

import { useTheme } from "styled-components";

import { createPortal } from "react-dom";

// components
import { TextInput } from "components/ui-kit/inputs/TextInput";
import ButtonIcon from "components/ui-kit/ButtonIcon";
import VirtualKeyboard from "components/VirtualKeyboard";

// styled
import styled from "styled-components";

// mui
import { Stack } from "@mui/material";

// icons
import { Keyboard as KeyboardIcon } from "@mui/icons-material";

// product fallback image
import productFallbackImage from "assets/icons/product.png";

const SidebarStepSelectItem = ({
  // state
  products = [],
  loading = false,
  // dispatch
  fetchProducts = () => { },
  selectProduct = () => { },
}) => {

  const theme = useTheme();
  const keyboardRef = useRef(null);

  const [search, setSearch] = useState("");
  const [virtualKeyboard, setVirtualKeyboard] = useState(false);

  const toggleVirtualKeyboard = useCallback(() => {
    return setVirtualKeyboard((previous) => !previous);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => fetchProducts(search), 300);
    return () => clearTimeout(timeout);
  }, [search, fetchProducts]);

  useEffect(() => {
    if (!virtualKeyboard) return;
    keyboardRef.current?.setInput(search);
  }, [search, virtualKeyboard]);

  const handleScroll = useCallback(({ target }) => {
    if (loading) return;
    if (target.scrollHeight - (target.offsetHeight + target.scrollTop) < 100) {
      fetchProducts(search);
    }
  }, [search, loading]);

  return (
    <Fragment>

      {createPortal(
        <VirtualKeyboard
          isOpen={virtualKeyboard}
          ref={keyboardRef}
          onChange={setSearch}
        />,
        document.body,
      )}

      <Stack as={Wrapper}>

        <Search>
          <TextInput
            isTitle={false}
            title="Пошук позиції"
            type="text"
            width="100%"
            onChange={(event) => setSearch(event.target.value)}
            value={search}
            isStyle
            stylePadTop="0"
            styleMarg="0"
          />
          <ButtonIcon
            onClick={toggleVirtualKeyboard}
            icon={<KeyboardIcon />}
          />
        </Search>

        <Items theme={theme} onScroll={handleScroll}>
          {products.map((item, index) => (
            <ProdcutsItem
              key={index}
              onClick={selectProduct.bind(null, item)}
              disabled={loading}
            >
              <ProductImg src={item.image ?? productFallbackImage} alt={item.title_ua} />
              <ItemRow>
                <DivRowProd>{item.title_ua} <div>{item.restaurant}</div></DivRowProd>
              </ItemRow>
            </ProdcutsItem>
          ))}
        </Items>

      </Stack>

    </Fragment>
  );
}

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    background-color: transparent;
`;

const Search = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 45px;
    margin-bottom: 15px;
`;

const Items = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    overflow: auto;
`;

const ProdcutsItem = styled.li`
  display: flex;
  padding: 7px;
  background-color: #FFFFFF;
  border: ${(p) => p.theme.inputBorderDE};
  border-radius: 10px;
  color: #000;
  pointer-events: ${(p) => p.disabled ? "none" : "all"};

  &:hover {
    cursor: pointer;
    border: 1px solid ${(p) => p.theme.lightAccentColor};
  }

  ${(p) => p.disabled ? `
    opacity: 0.5;
  ` : ''}
`;

const ProductImg = styled.img`
  width: 50px;
  height: 100%;
  margin-right: 10px;
  border-radius: 10px;
`;

const DivRowProd = styled.div`
  display: flex;
  div {
    margin-left: auto;
    padding-left: 10px;
    font-size: 12px;
    color: #EDA240;
  }
`;

const ItemRow = styled.div`
    width: 100%;
`;

export default memo(SidebarStepSelectItem);
